export default "__VITE_ASSET__KY10e_wUtMddDOEHtdDYJg__";